<template>
  <el-row class="custom-promo-form">
    <el-row>
      <template v-for="(form, idx) in forms">
        <el-col :span="23" :key="idx" v-if="idx >= 0 && idx <= 1">
          <el-form-item size="small" :prop="form.id" :label="form.label" :rules="form.rules">
            <el-input
              v-if="form.type == 'text' || form.type == 'password' || form.type == 'number'"
              v-model="Promo[form.id]"
              :type="form.type"
              :placeholder="`Please input ${form.label}`"
            ></el-input>
            <el-input
              v-else-if="form.type == 'textarea'"
              type="textarea"
              :rows="2"
              :placeholder="`Please input ${form.label}`"
              v-model="Promo[form.id]"
            ></el-input>
          </el-form-item>
        </el-col>
      </template>
    </el-row>

    <el-row>
      <el-form-item label="Masa Berlaku" size="small">
        <el-col :span="11" class="mr-4">
          <el-date-picker
            type="datetime"
            placeholder="Pick a date"
            v-model="Promo[forms[2].id]"
            style="width: 100%;"
            @input="clearEndDate"
          ></el-date-picker>
        </el-col>
        <el-col :span="11">
          <el-date-picker
            type="datetime"
            placeholder="Pick a date"
            v-model="Promo[forms[3].id]"
            style="width: 100%;"
            :picker-options="forms[3].endDatePickerOptions"
          ></el-date-picker>
        </el-col>
      </el-form-item>
    </el-row>

    <!-- <el-row>
      <el-form-item :label="forms[4].label" prop="is_flashale" size="small">
        <el-switch v-model="Promo[forms[4].id]"></el-switch>
      </el-form-item>
    </el-row>-->

    <!-- <el-row v-if="Promo[forms[4].id]">
      <el-form-item label size="small">
        <el-col :span="11" class="mr-4">
          <el-date-picker
            type="datetime"
            placeholder="Pick a date"
            v-model="Promo[forms[5].id]"
            style="width: 100%;"
          ></el-date-picker>
        </el-col>
        <el-col :span="11">
          <el-date-picker
            type="datetime"
            placeholder="Pick a date"
            v-model="Promo[forms[6].id]"
            style="width: 100%;"
          ></el-date-picker>
        </el-col>
      </el-form-item>
    </el-row>-->

    <el-row>
      <el-col :span="23">
        <el-form-item
          size="small"
          :prop="forms[7].id"
          :label="forms[7].label"
          :rules="forms[7].rules"
        >
          <el-col :span="4">
            <el-input-number size="mini" v-model="Promo[forms[7].id]"></el-input-number>
          </el-col>
        </el-form-item>
      </el-col>
    </el-row>
    

    <el-row>
      <el-form-item label="Budget" size="small">
        <el-col :span="11" class="mr-4">
          <el-input-number size="mini" v-model="Promo[forms[8].id]"></el-input-number>
        </el-col>
        <el-col :span="11">
          <el-select v-model="Promo[forms[9].id]">
            <el-option
              v-for="item in forms[9].data"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-col>
      </el-form-item>
    </el-row>

    <el-row>
      <template v-for="(form, idx) in forms">
        <el-col :span="23" :key="idx" v-if="idx >= 10 && idx <= 13">
          <el-form-item size="small" :prop="form.id" :label="form.label" :rules="form.rules">
            <el-input
              v-if="form.type == 'text' || form.type == 'password' || form.type == 'number'"
              v-model="Promo[form.id]"
              :type="form.type"
              :placeholder="`Please input ${form.label}`"
            ></el-input>
            <el-select
              v-else-if="form.type == 'select'"
              v-model="Promo[form.id]"
              :placeholder="`Please select ${form.label}`"
            >
              <el-option
                v-for="item in form.data"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              ></el-option>
            </el-select>
            <el-switch v-else-if="form.type == 'switch'" v-model="Promo[form.id]"></el-switch>
          </el-form-item>
        </el-col>
      </template>
    </el-row>
    <el-row v-if="Promo.promoType === 'voucher'">
      <el-col :span="23">
        <el-form-item
          size="small"
          :prop="'voucher.voucherCode'"
          :label="forms[14].label"
          :rules="forms[14].rules"
        >
          <el-col :span="24">
            <el-input
              v-model="Promo.voucher[forms[14].id]"
              :type="forms[14].type"
              :placeholder="`Please input ${forms[14].label}`"
            ></el-input>
          </el-col>
        </el-form-item>
      </el-col>
    </el-row>
  </el-row>
</template>

<script>
export default {
  props: ["Promo"],
  data() {
    return {};
  },
  computed: {
    forms() {
      return [
        {
          type: "text",
          id: "title",
          label: "Promo Name",
          rules: [
            {
              required: true,
              message: "Promo Name is required",
              trigger: "blur"
            }
          ]
        },
        {
          type: "textarea",
          id: "description",
          label: "Description",
          rules: [
            {
              required: true,
              message: "Description is required",
              trigger: "blur"
            }
          ]
        },
        {
          type: "datetime",
          id: "startDatetime",
          label: "",
          rules: [
            {
              required: true,
              message: "Start Date is required",
              trigger: "blur"
            }
          ]
        },
        {
          type: "datetime",
          id: "endDatetime",
          label: "",
          rules: [
            {
              required: true,
              message: "End Date is required",
              trigger: "blur"
            }
          ],
            endDatePickerOptions: {
                disabledDate: this.disabledEndDate
            }
        },
        {
          type: "switch",
          id: "is_flashsale",
          label: "Flash Sale?",
          prop: false
        },
        {
          type: "datetime",
          id: "start_date_flash",
          label: "",
          rules: [
            {
              required: true,
              message: "Start Date is required",
              trigger: "blur"
            }
          ]
        },
        {
          type: "datetime",
          id: "end_date_flash",
          label: "",
          rules: [
            {
              required: true,
              message: "End Date is required",
              trigger: "blur"
            }
          ]
        },
        {
          type: "number",
          id: "priority",
          label: "Priority",
          rules: [
            {
              required: true,
              message: "Priority is required",
              trigger: "blur"
            }
          ]
        },
        {
          type: "number",
          id: "budget",
          label: "",
          rules: [
            {
              required: true,
              message: "Budget is required",
              trigger: "blur"
            }
          ]
        },
        {
          type: "select",
          id: "budgetUnit",
          label: "",
          rules: [
            {
              required: true,
              message: "Tipe Product by is required",
              trigger: "change"
            }
          ],
          data: [
            {
              name: "Karton",
              value: "Karton"
            },
            {
              name: "Value",
              value: "value"
            },
            {
              name: "Box",
              value: "Box"
            }
          ]
        },
        {
          type: "text",
          id: "budgetBy",
          label: "Budget By",
          rules: [],
        },
        {
          type: "text",
          id: "mailingNumber",
          label: "No. Surat",
          rules: [
            {
              required: true,
              message: "No. Surat is required",
              trigger: "blur"
            }
          ]
        },
        {
          type: "select",
          id: "promoType",
          label: "Promo Type",
          rules: [
            {
              required: true,
              message: "Promo Type is required",
              trigger: "change"
            }
          ],
          data: [
            {
              name: "Promo to Item",
              value: "promo_to_item"
            },
            {
              name: "Strata to Item",
              value: "strata_disc"
            },
            {
              name: "Voucher to Item",
              value: "voucher"
            },
            {
              name: "Promo to Cart",
              value: "promo_to_cart"
            },
            {
              name: "Payment Method to Cart",
              value: "payment_method_to_cart"
            },
            {
              name: "Push to Cart",
              value: "push_to_cart"
            }
          ]
        },
        {
          type: "switch",
          id: "isActive",
          label: "Active",
          rules: [
            {
              required: true,
              message: "Active is required",
              trigger: "change"
            }
          ]
        },
        {
          type: "text",
          id: "voucherCode",
          label: "Voucher Code",
          rules: [
           {
              required: true,
              message: "Voucher is required",
              trigger: "blur"
            }
          ]
        },
      ];
    }
  },
  methods: {
    // checkForm: function (e) {
    //   this.errors = [];

    //   if (this.startDatetime.onchange(this.endDatetime)) {
    //     this.errors.push("Start Date must be earlier than End Date");
    //   }

    //   e.preventDefault();
    // }
    disabledEndDate (date) {
        return date.getTime() < new Date( this.Promo['startDatetime'])
    },
    clearEndDate (date) {
        if (new Date(this.Promo['endDatetime'])<=date) this.Promo[this.forms[3].id] = null;
    }
  }
};
</script>

<style>
.custom-promo-form /deep/ .el-form-item__content {
  margin-left: 120px;
}
</style>
